
import { FILE_UPLOAD_INPUT } from "@mavichpe/dynamic-forms";

const LoadXmlFormConfig = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": FILE_UPLOAD_INPUT,
                        "name": "xml",
                        "label": "Archivo Documento Electronico",
                        "sizing": {
                            "sm": {
                                "size": 6,
                                "offset": 0
                            }
                        },
                        "inputConfig": {
                            "maxFiles": 1,
                            "allowMultiple": false,
                            "instantUpload": false,
                        }
                    },
                ]
            ]
        }
    ],
};


export default LoadXmlFormConfig;